import React from "react";
import { AccordionPanel } from "@chakra-ui/react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { options } from "api/contentful/options";

interface Props {
  description: any;
}

const Description: React.FC<Props> = ({ description }: Props) => {
  return (
    <AccordionPanel px={12} pt={3} pb={6}>
      {description.changes &&
        documentToReactComponents(description.changes, options)}
    </AccordionPanel>
  );
};

export default Description;
